import type { NotificationSettingsInput, NotificationType } from "@/api-types";

const PUSH_SETTINGS_KEY = "woofapy_push_settings";

// Helper functions for local storage
export const getPushSettings = (): NotificationSettingsInput => {
  try {
    const stored = localStorage.getItem(PUSH_SETTINGS_KEY);
    return stored
      ? JSON.parse(stored)
      : { updates: true, messages: true, news: true };
  } catch {
    return { updates: true, messages: true, news: true };
  }
};

export const setPushSettings = (settings: NotificationSettingsInput) => {
  localStorage.setItem(PUSH_SETTINGS_KEY, JSON.stringify(settings));
};

// Map notification types to setting keys
const getNotificationSettingKey = (
  notificationType: NotificationType,
): keyof NotificationSettingsInput | null => {
  switch (notificationType) {
    case "UPDATE":
    case "SESSION_UPDATE":
    case "SESSION_REQUESTED":
    case "SESSION_CONFIRMED":
    case "SESSION_COMPLETED":
    case "SESSION_CANCELLED":
    case "GROUP_JOIN_REQUESTED":
    case "GROUP_JOIN_APPROVED":
    case "GROUP_JOIN_REJECTED":
      return "updates";
    case "CHAT_MESSAGE":
    case "GROUP_CHAT_MESSAGE":
      return "messages";
    case "NEWS":
      return "news";
  }
};

// Check if push notifications are enabled for a specific notification type
export const isPushNotificationEnabled = (
  notificationType: NotificationType,
): boolean => {
  const settingKey = getNotificationSettingKey(notificationType);
  if (!settingKey) {
    return true; // Default to enabled for unknown types
  }

  const settings = getPushSettings();
  return settings[settingKey];
};
